import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="categories" className="w-full py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="flex items-end justify-between mb-8 md:mb-10">
            <div>
              <p className="text-xs md:text-sm text-foreground-500 font-medium tracking-wide mb-2">
                / SHOP BY CATEGORY
              </p>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
                Explore <span className="text-primary-500">Collections</span>
              </h2>
            </div>
            <span className="inline-flex items-center px-3 py-1.5 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
              {categories.length} Collections
            </span>
          </div>

          {/* Desktop category grid */}
          <div className="hidden md:grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
            {categories.map((cat, idx) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onMouseEnter={() => setActiveIndex(idx)}
                className="group block bg-background-50 rounded-xl p-3 md:p-4 transition-all duration-300 hover:bg-primary-100/50 cursor-pointer"
              >
                <div className="aspect-square rounded-lg overflow-hidden mb-3 md:mb-4">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} collection at ACBuySpreadsheet`}
                    title={`ACBuySpreadsheet ${cat.name} Collection`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <p className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                  {cat.name}
                </p>
                <p className="text-xs text-foreground-500 text-center mt-1">
                  {cat.itemCount}
                </p>
              </a>
            ))}
          </div>

          {/* Mobile horizontal scroll */}
          <div className="md:hidden flex gap-3 overflow-x-auto pb-4 snap-x snap-mandatory">
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[160px] snap-start bg-background-50 rounded-xl p-3 cursor-pointer"
              >
                <div className="aspect-square rounded-lg overflow-hidden mb-3">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} collection`}
                    title={`ACBuySpreadsheet ${cat.name}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <p className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                  {cat.name}
                </p>
              </a>
            ))}
          </div>

          {/* All categories quick links */}
          <div className="mt-8 md:mt-10">
            <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3 text-center">
              Quick Category Links
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-1.5 bg-background-50 border border-background-200/70 text-foreground-700 text-xs font-medium rounded-full hover:bg-primary-100/50 hover:text-foreground-900 transition-all cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}